import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from 'gung-standard';
import { Observable } from 'rxjs';
import { ColmecTirePrice } from '../components/working-order/colmec-working-order-wrapper/colmec-working-order-wrapper.component';

export interface ColmecTire {
  id: string;
  name: string;
  extra: { [s: string]: any };
  tireType: string;
  description: string;
  supplierArticleNumber: string;
  supplierName: string;
  width: string;
  aspectRatio: string;
  diameter: string;
  measures: string;
  treadPattern: string;
  retreaded: boolean;
  artnrtillvalart: string;
  manufacturer: string;
  price: ColmecTirePrice;
  errors?: { [s: string]: string };
}

@Injectable({
  providedIn: 'root'
})
export class ColmecTireWorkingOrderService {
  protected baseUrl: string = 'json/colmec-tires/list/by-agreement-id';

  constructor(protected http: HttpClient) {}

  getWorkingOrderTiresList(agreementId: string): Observable<ColmecTire[]> {
    return this.http.get<ColmecTire[]>(`${this.baseUrl}/${agreementId}`);
  }
}
